import type { SVGProps } from 'react';

const RegisterVilla = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height={211}
    viewBox="0 0 212 211"
    width={212}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <clipPath id="a">
      <path d="m0 0h212v211h-212z" />
    </clipPath>
    <mask id="b" height={211} maskUnits="userSpaceOnUse" width={212} x={0} y={0}>
      <path d="m0 0h212v211h-212z" fill="#fff" />
    </mask>
    <g clipPath="url(#a)">
      <g mask="url(#b)">
        <path
          d="m106.5 202c53.295 0 96.5-43.205 96.5-96.5 0-53.2955-43.205-96.5-96.5-96.5-53.2955 0-96.5 43.2045-96.5 96.5 0 53.295 43.2045 96.5 96.5 96.5z"
          fill="#dadada"
        />
        <path d="m44 41h125v148h-125z" fill="#fff" />
        <path d="m45 42h123v146h-123z" stroke="#054b54" strokeWidth={2} />
        <g stroke="#d3e5e7">
          <path d="m58.5 128.5h45" />
          <path d="m110.5 128.5h45" />
          <path d="m58.5 136.5h97.121" />
          <path d="m58.5 144.5h97.121" />
        </g>
        <path
          d="m106.5 118.5c13.255 0 24-10.745 24-24 0-13.2548-10.745-24-24-24-13.2548 0-24 10.7452-24 24 0 13.255 10.7452 24 24 24z"
          stroke="#e3e3e3"
        />
        <svg
          enableBackground="new -204 330.8 202.4 135.5"
          height={20}
          viewBox="-204 330.8 202.4 135.5"
          width={20}
          x={50}
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          y={45}
          {...props}
        >
          <g preserveAspectRatio="xMaxYMid meet" transform="translate(-12.72 -12.19)">
            <path
              d="m11.1 388.8c0 11.5-9.8 20.9-21.9 20.9s-21.9-9.3-21.9-20.9c0-11.5 9.8-20.9 21.9-20.9s21.9 9.4 21.9 20.9"
              fill="#e30613"
            />
            <path d="m-2.6 388.8-8.2-7.8-8.2 7.8 8.2 7.8zm-8.2 14.5-15.3-14.5 15.3-14.5 15.3 14.5z" fill="#fff" />
            <g fill="#274149">
              <path d="m-130.4 398.8-23.3 48.2c-1.2 2.7-4 4.4-7 4.2-3 .2-5.8-1.5-7-4.2l-23.5-48.2h10.8l19.6 40.4 19.8-40.4z" />
              <path d="m-120.1 450.6h-10.3v-51.8h10.3zm1.6-63.6c0 1.6-.8 3.1-2.1 4.1-1.3 1.2-3.1 1.8-4.9 1.8-1.7 0-3.4-.6-4.8-1.7-1.3-1-2-2.5-2-4.1s.7-3.2 1.9-4.2c1.3-1.2 3.1-1.8 4.8-1.8 1.8-.1 3.5.6 4.9 1.7 1.4 1 2.2 2.6 2.2 4.2" />
              <path d="m-113.3 380.5h10.3v70.1h-10.3z" />
              <path d="m-96.2 380.5h10.3v70.1h-10.3z" />
              <path d="m-41.6 435.9v-9.9c0-1.1-.8-1.6-2.4-1.6h-20c-5 0-7.4 2.1-7.4 6.4v5.1c0 1.7.8 3.3 2.2 4.3 1.6 1.1 3.5 1.7 5.4 1.6h15c4.8-.1 7.2-2.1 7.2-5.9m10.3 1.7c.1 3.5-1.3 7-3.9 9.4s-6.2 3.6-10.7 3.6h-19.8c-4.8 0-8.5-1-11.4-3.1-3-2.1-4.7-5.6-4.6-9.3v-9.3c0-4.1 1.4-7.2 4.1-9.5s6.5-3.4 11.3-3.4h24.8c-.1-2.9-.6-5-1.5-6.2-1.1-1.5-3.3-2.3-6.6-2.3h-25.9v-8.7h27.3c11.3 0 16.9 4.4 16.9 13.1z" />
            </g>
          </g>
        </svg>
        <path d="m72 52h86v9h-86z" fill="#f3f6f4" />
        <path d="m84 155h47v16h-47z" fill="#dadada" />
        <g strokeLinejoin="round" strokeWidth={2}>
          <path
            d="m112.233 178.515-4.3 2.966-1.1-16.616 6.376 3.584 7.552 4.607-4.138 2.545 4.138 5.88-4.935 3.019z"
            fill="#fff"
            stroke="#043764"
          />
          <g stroke="#dadada" strokeLinecap="round">
            <path d="m107 110c8.56 0 15.5-6.94 15.5-15.5 0-8.5604-6.94-15.5-15.5-15.5-8.5604 0-15.5 6.9396-15.5 15.5 0 8.56 6.9396 15.5 15.5 15.5z" />
            <path d="m96.5 105.835c.9625-1.984 2.464-3.657 4.333-4.827 1.869-1.1705 4.029-1.7912 6.234-1.7912s4.365.6207 6.234 1.7912c1.869 1.17 3.371 2.843 4.333 4.827" />
          </g>
        </g>
        <path d="m107 96c3.314 0 6-2.6863 6-6s-2.686-6-6-6-6 2.6863-6 6 2.686 6 6 6z" fill="#fff" />
        <path
          d="m107 95c2.761 0 5-2.2386 5-5s-2.239-5-5-5-5 2.2386-5 5 2.239 5 5 5z"
          stroke="#dadada"
          strokeWidth={2}
        />
      </g>
    </g>
  </svg>
);
export default RegisterVilla;
